module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "fluid narrow",
    attrs: {
      "dialog": "modal-x-sm"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Edit note")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "wrapper fs-normal"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clonedNote.text),
      expression: "clonedNote.text"
    }],
    attrs: {
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.clonedNote.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.clonedNote, "text", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-all",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('vue-select', {
    attrs: {
      "options": _vm.types
    },
    model: {
      value: (_vm.clonedNote.type),
      callback: function($$v) {
        _vm.$set(_vm.clonedNote, "type", $$v)
      },
      expression: "clonedNote.type"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn yes wide ml-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-1c1539b6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c1539b6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/NoteEdit.vue
// module id = 1561
// module chunks = 0